module.exports = __webpack_public_path__ + "img/table-cells.57013888.svg";